import styled from 'styled-components';

const ButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  font-family: Roboto Bold;
  font-style: normal;
  width: ${props => props.width};
  cursor: pointer;
  padding: 8px;
  font-weight: 600;
  color: ${props => props.color};
  background: ${props => props.bgColor};
  height: ${props => props.height};
  font-size: ${props => props.fontSize};
  border: ${props => props.borderWidth} solid ${props => props.borderColor};
  border-radius: ${props => props.borderRadius};

  * {
    cursor: pointer;
  }
  &:active {
    opacity: 0.8;
  }
  svg {
    margin-right: 8px;
  }

  label {
    margin: 0px auto;
    font-weight: 400;
    color: ${props => props.color};
    font-size: ${props => props.fontSize};
  }

  &.primary {
    background: ${({ theme }) => theme.colors.zervioBlue};
    border: 1px solid ${({ theme }) => theme.colors.zervioBlue};
    width: 100%;

    label {
      color: #ffffff;
    }
    &:hover {
      background: ${({ theme }) => theme.colors.zervioBlueSecondary3};
      border: 1px solid ${({ theme }) => theme.colors.zervioBlueSecondary3};
    }
  }

  &.secondary {
    background: ${({ theme }) => theme.colors.ZenDefaultSecondary};
    border: 1px solid ${({ theme }) => theme.colors.ZenDefaultSecondary};
    width: 100%;

    label {
      color: #ffffff;
    }
  }

  &.negative {
    background: ${({ theme }) => theme.colors.ZenNegative};
    border: 1px solid ${({ theme }) => theme.colors.ZenNegative};
    width: 100%;

    label {
      color: #ffffff;
    }
  }

  &.primary-white {
    background: #ffffff;
    border: 1px solid ${({ theme }) => theme.colors.zervioBlue};

    label {
      color: ${({ theme }) => theme.colors.zervioBlue};
    }
  }

  &.default-secondary {
    background: ${({ theme }) => theme.colors.zervioBlueSecondary2};
    border: 1px solid ${({ theme }) => theme.colors.zervioBlueSecondary2};

    label {
      color: ${({ theme }) => theme.colors.zervioBlue};
    }
  }

  &.disabled {
    opacity: 0.3;
    label {
      color: #ffffff;
    }

    svg {
      * {
        stroke: #ffffff;
      }
    }
  }

  &.primary-grey {
    background: #ffffff;
    border: 1px solid ${({ theme }) => theme.colors.ZenGray2};

    label {
      color: ${({ theme }) => theme.colors.Regular_Text};
    }
  }
`;

export default ButtonWrapper;
